<template>
    <section>
        <v-card>
            <v-card-title class="text-h6">
                Modification du podcast : {{ podcastInfo.name }}
            </v-card-title>
            <v-row style="margin: 20px">
                <v-col cols="12" sm="12" md="12">
                    <v-select v-model="podcastInfo.actualityId" clearable label="dossier" :items="dossierArray"
                        item-text="title" item-value="id" outlined></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                    <v-text-field v-model="podcastInfo.name" label="Nom du podcast"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                    <v-text-field v-model="podcastInfo.nameEn" label="Nom du podcast (en)"></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" md="6">
                    <vue-upload-multiple-image v-if="isDataLoaded" style="margin-left: 160px" v-model="images_BG" :data-images="images_BG"
                        accept="image/*" name="images" drag-text="Veuillez ajouter une image Sans arrière-plan"
                        browse-text="Browse image" primary-text="Image" mark-is-primary-text="Set default image"
                        :min-image="1" :multiple="false" :showEdit="false" popup-text="Description default image"
                        drop-text="Drag and drop" @upload-success="uploadImageSuccess" @before-remove="beforeRemove_BG"
                        :idUpload="images_BGId">
                    </vue-upload-multiple-image>
                    <v-progress-linear v-if="showlowding_BG && uploadPercentage_BG < 100"
                        style="max-width: 190px; margin-left: 160px" color="primary" indeterminate rounded
                        height="15"><strong>{{ Math.ceil(uploadPercentage_BG) }}%</strong></v-progress-linear>
                </v-col>

                <v-col cols="12" sm="6" md="6">
                    <label>Audio File
                        <input type="file" accept="audio/*" @change="handleAudioUpload($event)" />
                        <v-progress-linear v-if="showLoading_audio" style="max-width: 300px; margin-top: 10px"
                            color="primary" indeterminate rounded height="6"></v-progress-linear>
                    </label>
                </v-col>
            </v-row>
            <v-row align="center" style="margin: 20px" v-show="echec">
                <v-col cols="6" sm="6" md="6"></v-col>
                <v-col cols="6" sm="6" md="6">
                    <span style="color: red">Échec d'upload du fichier audio</span>
                </v-col>
            </v-row>

            <v-row align="center" style="margin: 20px" v-if="podcastInfo.fileUrl">
                <v-col cols="6" sm="6" md="6">
                    <span>Fichier audio actuel :</span>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                    <vuetify-audio style="height: 100px; margin-top: 10px; margin-bottom: 10px"
                        :file="podcastInfo.fileUrl" :autoPlay="false" :flat="false" :playIcon="icons.mdiPlay"
                        :pauseIcon="icons.mdiPause" :stopIcon="icons.mdiStop" :refreshIcon="icons.mdiRefresh"
                        :volumeHighIcon="icons.mdiVolumeHigh" :volumeMuteIcon="icons.mdiVolumeMute"></vuetify-audio>
                </v-col>
            </v-row>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error darken-1 " @click="goBack()" text>
                    Annuler
                </v-btn>
                <v-btn :disabled="!hasChanged()" color="info darken-1 " @click="updatePodcast()" text>
                    Confirmer
                </v-btn>
            </v-card-actions>
        </v-card>
    </section>
</template>

<script>
import { VuetifyAudio } from "vuetify-audio";
import VueUploadMultipleImage from "vue-upload-multiple-image";
import store from "@/store/image";
import constants from '@/utils/constants';
import { getActualityByCategory } from '@/views/qorani/services/services';
import axios from 'axios';
import { mdiPlay, mdiPause, mdiStop, mdiRefresh, mdiVolumeHigh, mdiVolumeMute } from '@mdi/js';

export default {
    components: { VuetifyAudio, VueUploadMultipleImage },
    data() {
        return {
            podcastInfo: {
                id: "",
                name: "",
                nameEn: "",
                actualityId: null,
                fileId: null,
                fileUrl: "",
                imgDBId: null,
                imgDBUrlId: null
            },
            originalPodcastInfo: {
                id: "",
                name: "",
                nameEn: "",
                actualityId: null,
                fileId: null,
                fileUrl: "",
                imgDBId: null,
                imgDBUrlId: null
            },
            images_BG: [],
            showlowding_BG: false,
            uploadPercentage_BG: null,
            images_BGId: "1",
            isDataLoaded: false,
            dossierArray: [],
            showLoading_audio: false,
            echec: false,
            icons: {
                mdiPlay,
                mdiPause,
                mdiStop,
                mdiRefresh,
                mdiVolumeHigh,
                mdiVolumeMute
            }
        };
    },
    async beforeRouteEnter(to, from, next) {
        const podcastId = to.params.id;
        try {
            const response = await axios.get(`${constants.QORANI}podcast/get/${podcastId}`);
            next((vm) => {
                const imgId = response.data.imgDBId || response.data.imgDBUrlId || null;
                vm.podcastInfo = {
                    id: response.data.id,
                    name: response.data.name,
                    nameEn: response.data.nameEn || "",
                    actualityId: response.data.actualityId,
                    fileId: response.data.fileId,
                    fileUrl: response.data.fileUrl,
                    imgDBId: imgId,
                    imgDBUrlId: imgId
                };
                vm.originalPodcastInfo = {
                    id: response.data.id,
                    name: response.data.name,
                    nameEn: response.data.nameEn || "",
                    actualityId: response.data.actualityId,
                    fileId: response.data.fileId,
                    fileUrl: response.data.fileUrl,
                    imgDBId: imgId,
                    imgDBUrlId: imgId
                };
                if (imgId) {
                    vm.images_BG.push({
                        name: "",
                        path: `${constants.QORANI}fileDB/files/${imgId}`,
                        highlight: 1,
                        default: 1,
                    });
                }
                vm.isDataLoaded = true;
            });
        } catch (error) {
            console.error("Error fetching podcast details:", error);
            next(null);
        }
    },
    methods: {
        hasChanged() {
            return (
                this.podcastInfo.name !== this.originalPodcastInfo.name ||
                this.podcastInfo.nameEn !== this.originalPodcastInfo.nameEn ||
                this.podcastInfo.actualityId !== this.originalPodcastInfo.actualityId ||
                this.podcastInfo.fileId !== this.originalPodcastInfo.fileId ||
                this.podcastInfo.imgDBId !== this.originalPodcastInfo.imgDBId ||
                this.podcastInfo.imgDBUrlId !== this.originalPodcastInfo.imgDBUrlId
            );
        },
        async getAllDossier() {
            try {
                const response = await getActualityByCategory("ARTICLE");
                this.dossierArray = response;
                return response;
            } catch (error) {
                console.error("Error fetching dossiers:", error);
                return [];
            }
        },
        async uploadImageSuccess(formData, index, fileList) {
            try {
                await store.dispatch("uploadImageSuccess", {
                    formData,
                    index,
                    fileList,
                });
                const imageId = store.state.imageId;
                this.podcastInfo.imgDBUrlId = imageId;
                this.podcastInfo.imgDBId = imageId;
                console.log("Image id :", imageId);
            } catch (error) {
                console.error("Failed to upload image:", error);
            }
        },
        beforeRemove_BG(index, done, fileList) {
            this.showlowding_BG = false;
            this.uploadPercentage_BG = 0;
            const r = confirm("Supprimer l'image ?");
            if (r === true) {
                this.podcastInfo.imgDBUrlId = null;
                this.podcastInfo.imgDBId = null;
                this.images_BG.splice(index, 1);
                done();
            }
        },
        handleAudioUpload(event) {
            this.echec = false;
            this.showLoading_audio = true;
            const file = event.target.files[event.target.files.length - 1];
            const apiEndpoint = `${constants.QORANI}files/uploadABSPodcast`;
            const folderId = "c43816a1-cc90-48fd-b855-25ddbf57bb78";
            const libraryIdt = "6b9fc4e1-f445-47f8-95fc-69a97d3dba85";
            const title = this.podcastInfo.name + '_' + Date.now();

            const customFormData = new FormData();
            customFormData.append("file", file);
            customFormData.append("folder", folderId);
            customFormData.append("library", libraryIdt);
            customFormData.append("title", title);
            customFormData.append("fromPostman", false);

            axios
                .post(apiEndpoint, customFormData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((response) => {
                    console.log(response);

                    if (response.data.id) {
                        console.log("Audio upload success:", response.data);
                        this.podcastInfo.fileId = response.data.id;
                        this.podcastInfo.fileUrl = response.data.downloadAudioBookUrl || "";
                        this.showLoading_audio = false;
                        event.target.value = null;
                    } else {
                        this.showLoading_audio = false;
                        this.echec = true;
                        event.target.value = null;
                    }
                })
                .catch((error) => {
                    console.error("Error uploading audio:", error);
                    this.showLoading_audio = false;
                    this.echec = true;
                });
        },
        async updatePodcast() {
            try {
                const imgId = this.podcastInfo.imgDBUrlId || this.podcastInfo.imgDBId;
                const payload = {
                    name: this.podcastInfo.name,
                    nameEn: this.podcastInfo.nameEn,
                    actualityId: this.podcastInfo.actualityId,
                    fileId: this.podcastInfo.fileId,
                    imgDBUrlId: imgId,
                    imgDBId: imgId
                };
                console.log(payload);
                const response = await axios.post(`${constants.QORANI}podcast/edit/${this.podcastInfo.id}`, payload);
                console.log(response);
                if (response.data) {
                    this.$router.push('/Podcast');
                }
            } catch (error) {
                console.error("Error updating podcast:", error);
            }
        },
        goBack() {
            this.$router.push('/Podcast');
        }
    },
    async created() {
        await this.getAllDossier();
    }
}
</script>

<style></style>
